<template>
  <div class="main-content">
    <div class="section__content section__content--p30">
      <div class="container-fluid job-info-container">
        <v-card class="p-b-40 p-t-30 p-l-30 p-r-30">
          <div class="el-loading-mask" style="bottom: 0" v-if="loading">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>
          <!-- Job Name -->
          <div class="row">
            <div class="col-md-12 header">
              <h3 class="title-7 p-b-10">
                <v-btn
                  text icon
                  class="m-0"
                  @click="$router.back()">
                  <i class="zmdi zmdi-long-arrow-left"></i>
                </v-btn>
                {{ job.name }} : log
              </h3>
              <span class="p-l-20 status--gray">ID={{ job.id }}</span>
            </div>
          </div>
          <v-divider></v-divider>
          <!-- Status and general Info -->
          <div class="row">
            <div class="col-md-2">
              <div class="info-title">Job status</div>
              <i class="fa fa-clock job-status--paused"
                 v-if="jobStatus === 'Pending'">
              </i>
              <i class="fa fa-circle-notch fa-spin job-status--finished"
                 v-if="jobStatus === 'Processing'">
              </i>
              <i class="fa fa-check-circle job-status--finished"
                 v-if="jobStatus === 'Done'">
              </i>
              <i class="fa fa-exclamation-circle job-status--failed"
                 v-if="jobStatus === 'Input Failed' || jobStatus === 'Output Failed'">
              </i>
              <span class="p-l-10">{{ jobStatus }}</span>
            </div>
            <div class="col-md-3">
              <div class="info-title">Profile</div>
              <div class="p-b-5">
                {{ job.profile.name | truncate(25) }}
              </div>
            </div>
            <div class="col-md-1">
              <div>
                <a href="https://hls-js.netlify.app/demo/" target="_blank">
                  <i class="fa fa-play-circle p-r-5"></i> Stream Tester
                </a>
              </div>
            </div>
            <div class="col-md-2">
              <div class="info-title">
                <i class="zmdi zmdi-calendar p-r-10"></i>Submitted
              </div>
              <div>
                {{ formatTime(job.create_time) }}
              </div>
            </div>
            <div class="col-md-2">
              <div class="info-title">
                <i class="zmdi zmdi-calendar p-r-10"></i>Finished
              </div>
              <div>
                <span v-if="job.state === 'done'">
                  {{ formatTime(job.update_time) }}
                </span>
                <span v-else>
                  <i class="zmdi zmdi-more"></i>
                </span>
              </div>
            </div>
            <div class="col-md-2">
              <div class="info-title">
                <i class="zmdi zmdi-time p-r-5"></i>
                Total job time
              </div>
              <div>
                <span v-if="job.state === 'done'">
                  {{ jobTime }}
                </span>
                <span v-else>
                  {{ jobTimeCalc }}
                </span>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <!-- Input & Output -->
          <div class="row">
            <div class="col-md-12" v-html="log" style="white-space: pre-wrap; color: #676767; font-size: 14px;"></div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

function secondsToDuration(secs) {
  const hours = Math.floor(moment.duration(secs, 'seconds').asHours());
  const minutes = moment.duration(secs, 'seconds').minutes();
  const seconds = moment.duration(secs, 'seconds').seconds();
  return hours > 0 ? `${hours}h ${minutes}m ${seconds}s` : `${minutes}m ${seconds}s`;
}

export default {
  created() {
    const jobId = this.$route.params.id;
    this.getJobById(jobId, true);
    this.pollData(jobId);
    this.currentT = moment().unix();
    this.updateTimer();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  data() {
    return {
      job: {
        name: '',
        input: {
          url: '',
        },
        profile: {
          audio_template: { name: '' },
          video_template: { name: '' },
        },
        outputs: [],
      },
      log: '',
      currentT: '',
      jobTimeCalc: '',
      polling: null,
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    jobStatus() {
      if (this.job.input.state === 'pending') {
        return 'Pending';
      }
      if (this.job.input.state === 'processing') {
        return 'Processing';
      }
      if (this.job.input.state === 'error') {
        return 'Input Failed';
      }
      if (this.job.outputs.length) {
        if (this.job.outputs[0].state === 'pending') {
          return 'Processing';
        }
        if (this.job.outputs[0].state === 'error') {
          return 'Output Failed';
        }
        if (this.job.outputs[0].state === 'success') {
          return 'Done';
        }
      }
      return 'Processing';
    },
    jobTime() {
      if (this.job.state !== 'done') return '';
      const diff = moment(this.job.update_time).diff(moment(this.job.create_time), 'seconds');
      return secondsToDuration(diff);
    },
  },
  methods: {
    pollData(jobId) {
      this.polling = setInterval(() => {
        this.getJobById(jobId, false);
      }, 10000);
    },
    updateTimer() {
      setInterval(() => {
        if (this.job.state !== 'done') {
          const now = Date.now();
          const played = now - moment(this.job.create_time).utc();
          this.jobTimeCalc = moment.utc(played).format('HH:mm:ss');
        }
      }, 100);
    },
    getJobById(jobId, notification = false) {
      if (notification) {
        this.$store.commit('setPageLoader');
      }
      this.events = [];
      this.displayLogs = false;
      this.$store.dispatch('jobs/getJobById', jobId)
        .then((job) => {
          this.job = job;
          this.$store.dispatch('jobs/getFileJobLog', job.id)
            .then((metadata) => {
              this.log = metadata || 'no data';
            })
            .finally(() => this.$store.commit('resolvePageLoader'));
        })
        .catch((errorMsg) => {
          if (notification) {
            this.$toasted.error(errorMsg, {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 10000,
            });
          }
          this.$router.push({ name: 'FileTranscodingDashboard' });
        });
    },
    formatTime(time) {
      return moment(time).format('MMM D, YYYY HH:mm');
    },
  },
  watch: {
    '$route.params.id': function (newId, oldId) {
      if (newId !== oldId) {
        this.getJobById(newId);
      }
    },
  },
};
</script>
